/* ==========================================================================
   PALPA — Application JavaScript v2.0
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Announcement Bar & Sticky Header --- */
  const announcementBar = document.querySelector('.announcement-bar');
  const header = document.querySelector('[data-header]');
  const hasHero = !!document.querySelector('.hero');

  if (header) {
    function updateHeaderState() {
      var y = window.pageYOffset;

      // Announcement bar hides when scrolled past
      if (announcementBar) {
        announcementBar.style.transform = y > 80 ? 'translateY(-100%)' : '';
      }

      header.classList.remove('header--transparent', 'header--solid', 'header--scrolled');
      if (y > 80) {
        header.classList.add('header--scrolled'); // bg + top: 0
      } else if (hasHero) {
        header.classList.add('header--transparent'); // no bg, white text
      } else {
        header.classList.add('header--solid'); // bg + top: var(--announcement-height)
      }
    }

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  /* --- Mobile Menu --- */
  var hamburger = document.querySelector('[data-hamburger]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('active');
      mobileMenu.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });

    mobileMenu.querySelectorAll('.mobile-menu__link').forEach(function (link) {
      link.addEventListener('click', function () {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  /* --- Scroll Reveal Animations --- */
  var reveals = document.querySelectorAll('.reveal, .reveal--left, .reveal--right');
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
  }

  /* --- Hero Load Animation --- */
  var hero = document.querySelector('.hero');
  if (hero) {
    setTimeout(function () { hero.classList.add('loaded'); }, 100);
  }

  /* --- Announcement Rotator --- */
  var announcementItems = document.querySelectorAll('[data-announcement-item]');
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (announcementItems.length > 1 && !prefersReducedMotion) {
    var announcementIdx = 0;
    setInterval(function () {
      announcementItems[announcementIdx].classList.remove('is-active');
      announcementIdx = (announcementIdx + 1) % announcementItems.length;
      announcementItems[announcementIdx].classList.add('is-active');
    }, 4500);
  }

  /* --- Cart Auto-submit on Qty Change --- */
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    var cartSubmitTimer;
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(cartSubmitTimer);
        cartSubmitTimer = setTimeout(function () {
          cartForm.submit();
        }, 400);
      });
    });
  }

  /* --- Quantity Selector --- */
  document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('input[type="number"]');
      var v = parseInt(input.value, 10) || 1;
      if (v > parseInt(input.min || '1', 10)) input.value = v - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('input[type="number"]');
      var v = parseInt(input.value, 10) || 1;
      var max = parseInt(input.max || '99', 10);
      if (v < max) input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- Wishlist (local persistence) --- */
  var wishlistKey = 'palpa.wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(wishlistKey)) || []; } catch (e) { return []; }
  }
  function writeWishlist(list) { localStorage.setItem(wishlistKey, JSON.stringify(list)); }
  var savedWishlist = readWishlist();
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    var pid = btn.dataset.productId;
    if (savedWishlist.indexOf(pid) > -1) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var list = readWishlist();
      var idx = list.indexOf(pid);
      if (idx > -1) { list.splice(idx, 1); btn.classList.remove('is-active'); }
      else { list.push(pid); btn.classList.add('is-active'); }
      writeWishlist(list);
    });
  });

  /* --- Sticky Mobile Add-to-Cart --- */
  var stickyBar = document.querySelector('[data-product-sticky]');
  var primaryCta = document.querySelector('.product-page__add-to-cart');
  var stickyCta = document.querySelector('[data-sticky-cta]');
  if (stickyBar && primaryCta && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-bar');
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(primaryCta);

    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        primaryCta.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { primaryCta.focus(); }, prefersReducedMotion ? 0 : 400);
      });
    }
  }

  /* --- Product Info Tabs (Horizontal) --- */
  document.querySelectorAll('.product-info-tab__header').forEach(function (header) {
    header.addEventListener('click', function () {
      var tabName = this.dataset.tab;
      var wrapper = this.closest('.product-info-tabs');
      if (!wrapper) return;
      wrapper.querySelectorAll('.product-info-tab__header').forEach(function (h) {
        h.classList.remove('active');
        h.setAttribute('aria-selected', 'false');
      });
      wrapper.querySelectorAll('.product-info-tab__panel').forEach(function (p) {
        p.classList.remove('active');
      });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      var panel = wrapper.querySelector('.product-info-tab__panel[data-panel="' + tabName + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  /* --- Product Tabs (Accordion) --- */
  document.querySelectorAll('.product-tab__header').forEach(function (tabHeader) {
    tabHeader.addEventListener('click', function () {
      var tab = this.closest('.product-tab');
      var content = tab.querySelector('.product-tab__content');
      var isActive = tab.classList.contains('active');

      document.querySelectorAll('.product-tab').forEach(function (t) {
        t.classList.remove('active');
        var h = t.querySelector('.product-tab__header');
        if (h) h.setAttribute('aria-expanded', 'false');
        t.querySelector('.product-tab__content').style.maxHeight = null;
      });

      if (!isActive) {
        tab.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  var firstTab = document.querySelector('.product-tab');
  if (firstTab) {
    firstTab.classList.add('active');
    var firstHeader = firstTab.querySelector('.product-tab__header');
    if (firstHeader) firstHeader.setAttribute('aria-expanded', 'true');
    var fc = firstTab.querySelector('.product-tab__content');
    if (fc) fc.style.maxHeight = fc.scrollHeight + 'px';
  }

  /* --- Product Thumbnails --- */
  document.querySelectorAll('.product-page__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-page__main-image img');
      var newSrc = this.dataset.fullSrc || this.querySelector('img').src;
      document.querySelectorAll('.product-page__thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        var preload = new Image();
        preload.onload = function () {
          mainImg.src = newSrc;
          mainImg.srcset = '';
          mainImg.style.opacity = '1';
        };
        preload.onerror = function () { mainImg.style.opacity = '1'; };
        preload.src = newSrc;
      }
    });
  });
  var ft = document.querySelector('.product-page__thumb');
  if (ft) ft.classList.add('active');

  /* --- Product Image Zoom (Lightbox) --- */
  var mainImage = document.querySelector('.product-page__main-image img');
  if (mainImage) {
    mainImage.addEventListener('click', function () {
      if (!this.src) return;
      var hiSrc = this.src.replace(/width=\d+/, 'width=1800');
      var modal = document.createElement('div');
      modal.className = 'product-zoom-modal';
      modal.innerHTML =
        '<button type="button" class="product-zoom-modal__close" aria-label="Close zoom">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<img class="product-zoom-modal__img" src="' + hiSrc + '" alt="">';
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';

      function close() {
        modal.remove();
        document.body.style.overflow = '';
        document.removeEventListener('keydown', escHandler);
      }
      function escHandler(e) { if (e.key === 'Escape') close(); }
      modal.addEventListener('click', close);
      document.addEventListener('keydown', escHandler);
    });
  }

  /* --- Variant Switcher (Size selector + price/urgency/CTA update) --- */
  (function () {
    var variantScript = document.querySelector('[data-product-variants]');
    if (!variantScript) return;
    var variants;
    try { variants = JSON.parse(variantScript.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      // Add thousands separator
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    // EUR/ARG → AUS/UK + US conversion (unisex shoe sizing)
    var SIZE_CONVERSIONS = {
      '35': { aus: '2.5', us: '3.5' },
      '36': { aus: '3', us: '4' },
      '37': { aus: '4', us: '5' },
      '38': { aus: '5', us: '6' },
      '39': { aus: '5.5', us: '6.5' },
      '40': { aus: '6', us: '7' },
      '41': { aus: '7', us: '8' },
      '42': { aus: '8', us: '9' },
      '43': { aus: '9', us: '10' },
      '44': { aus: '10', us: '11' },
      '45': { aus: '11', us: '12' }
    };

    function formatSizeLabel(value) {
      var conv = SIZE_CONVERSIONS[String(value)];
      if (!conv) return ' · ' + value;
      return ' · ARG/EUR ' + value + ' · AUS ' + conv.aus + ' · US ' + conv.us;
    }

    function updateUI(variant) {
      if (!variant) return;

      // Variant ID in form
      var idInput = document.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      // Current price
      var priceCurrent = document.querySelector('[data-price-current]');
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);

      // Compare-at price (sale)
      var priceCompare = document.querySelector('[data-price-compare]');
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }

      // Urgency
      var urgency = document.querySelector('[data-urgency]');
      if (urgency) {
        var qtyEl = urgency.querySelector('[data-urgency-qty]');
        var showUrgency = variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 3;
        if (showUrgency) {
          if (qtyEl) qtyEl.textContent = variant.inventory_quantity;
          urgency.classList.add('is-visible');
        } else {
          urgency.classList.remove('is-visible');
        }
      }

      // Option value label (e.g., "Shoe size · ARG/EUR 45 · AUS 11 · US 12")
      ['option1', 'option2', 'option3'].forEach(function (key) {
        var display = document.querySelector('[data-option-value-display="' + key + '"]');
        if (!display || !variant[key]) return;
        if (display.hasAttribute('data-is-size')) {
          display.textContent = formatSizeLabel(variant[key]);
        } else {
          display.textContent = ' · ' + variant[key];
        }
      });

      // Add to cart button
      var btn = document.querySelector('[data-add-to-cart]');
      if (btn) {
        var available = btn.querySelector('[data-cta-available]');
        var soldout = btn.querySelector('[data-cta-soldout]');
        var ctaPrice = btn.querySelector('[data-cta-price]');
        if (variant.available) {
          btn.disabled = false;
          if (available) available.hidden = false;
          if (soldout) soldout.hidden = true;
          if (ctaPrice) ctaPrice.textContent = formatMoney(variant.price);
        } else {
          btn.disabled = true;
          if (available) available.hidden = true;
          if (soldout) soldout.hidden = false;
        }
      }

      // Sticky bar (mobile)
      var stickyPrice = document.querySelector('.product-sticky-bar__price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    function findVariantBySelectedOptions() {
      var selectedByOption = {};
      document.querySelectorAll('.product-page__size.active').forEach(function (btn) {
        var opt = btn.dataset.option; // option1 / option2 / option3
        selectedByOption[opt] = btn.dataset.value;
      });
      return variants.find(function (v) {
        for (var key in selectedByOption) {
          if (v[key] !== selectedByOption[key]) return false;
        }
        return true;
      });
    }

    document.querySelectorAll('.product-page__size:not(.unavailable)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionKey = this.dataset.option;
        // Mark this as active, unmark siblings within same option group
        var siblings = this.closest('.product-page__sizes').querySelectorAll('.product-page__size');
        siblings.forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');

        var variant = findVariantBySelectedOptions();
        updateUI(variant);
      });
    });

    // Initial sync on page load (so label shows formatted size conversion immediately)
    var initialVariant = findVariantBySelectedOptions();
    if (initialVariant) updateUI(initialVariant);
  })();

  /* --- Testimonials Slider --- */
  var slider = document.querySelector('.testimonials__slider');
  var prevBtn = document.querySelector('[data-testimonial-prev]');
  var nextBtn = document.querySelector('[data-testimonial-next]');
  if (slider && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function () { slider.scrollBy({ left: -360, behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { slider.scrollBy({ left: 360, behavior: 'smooth' }); });
  }

  /* --- FAQ Accordion --- */
  document.querySelectorAll('.faq-item__question').forEach(function (question) {
    question.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var answer = item.querySelector('.faq-item__answer');
      var isActive = item.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('active');
        i.querySelector('.faq-item__answer').style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* --- Contact Form --- */
  var contactForm = document.querySelector('.contact-form__form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var success = this.closest('.contact-form').querySelector('.contact-form__success');
      if (success) {
        this.style.display = 'none';
        success.style.display = 'block';
      }
    });
  }

  /* --- Smooth Anchor Scroll --- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(this.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* --- Lookbook Gallery Lightbox --- */
  (function () {
    var items = document.querySelectorAll('.lookbook__item');
    if (!items.length) return;

    var images = [];
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (img && img.src) {
        images.push({
          src: img.src.replace(/width=\d+/, 'width=1800'),
          alt: img.alt || ''
        });
      }
    });
    if (!images.length) return;

    var currentIndex = 0;
    var modal = null;

    function openModal(index) {
      currentIndex = index;
      modal = document.createElement('div');
      modal.className = 'gallery-modal';
      modal.innerHTML =
        '<button type="button" class="gallery-modal__close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<button type="button" class="gallery-modal__prev" aria-label="Previous image">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
        '</button>' +
        '<button type="button" class="gallery-modal__next" aria-label="Next image">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
        '</button>' +
        '<img class="gallery-modal__img" alt="">' +
        '<div class="gallery-modal__counter"><span class="gallery-modal__current">1</span> / ' + images.length + '</div>';
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      updateImage();

      modal.querySelector('.gallery-modal__close').addEventListener('click', closeModal);
      modal.querySelector('.gallery-modal__prev').addEventListener('click', function (e) { e.stopPropagation(); navigate(-1); });
      modal.querySelector('.gallery-modal__next').addEventListener('click', function (e) { e.stopPropagation(); navigate(1); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', keyHandler);
    }

    function closeModal() {
      if (!modal) return;
      modal.remove();
      modal = null;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', keyHandler);
    }

    function navigate(dir) {
      currentIndex = (currentIndex + dir + images.length) % images.length;
      updateImage();
    }

    function updateImage() {
      if (!modal) return;
      var img = modal.querySelector('.gallery-modal__img');
      var current = modal.querySelector('.gallery-modal__current');
      img.src = images[currentIndex].src;
      img.alt = images[currentIndex].alt;
      if (current) current.textContent = currentIndex + 1;
    }

    function keyHandler(e) {
      if (!modal) return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowLeft') navigate(-1);
      else if (e.key === 'ArrowRight') navigate(1);
    }

    items.forEach(function (item, idx) {
      item.addEventListener('click', function () { openModal(idx); });
    });
  })();

  /* --- Email Capture Popup (welcome offer) --- */
  (function () {
    var popup = document.querySelector('[data-email-popup]');
    if (!popup) return;

    var STORAGE_KEY = 'palpa.popup';
    var SESSION_KEY = 'palpa.popup.shown';
    var COOLDOWN_DAYS = 30;
    var SCROLL_TRIGGER_PCT = 40;
    var TIME_TRIGGER_MS = 25000;

    function readState() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { return {}; }
    }
    function writeState(state) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }

    function shouldShow() {
      var state = readState();
      if (state.subscribed) return false;
      if (state.dismissedAt) {
        var daysSince = (Date.now() - state.dismissedAt) / 86400000;
        if (daysSince < COOLDOWN_DAYS) return false;
      }
      try {
        if (sessionStorage.getItem(SESSION_KEY)) return false;
      } catch (e) {}
      return true;
    }

    var openOnce = false;
    function openPopup() {
      if (openOnce) return;
      if (!shouldShow()) return;
      openOnce = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
      var input = popup.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus(); }, 400);
    }
    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var state = readState();
      if (!state.subscribed) {
        state.dismissedAt = Date.now();
        writeState(state);
      }
    }

    // Triggers
    function onScroll() {
      if (openOnce) { window.removeEventListener('scroll', onScroll); return; }
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = (window.pageYOffset / docHeight) * 100;
      if (pct >= SCROLL_TRIGGER_PCT) openPopup();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(openPopup, TIME_TRIGGER_MS);

    // Exit intent (desktop only, no mobile)
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY < 5 && !e.relatedTarget) openPopup();
      });
    }

    // Close handlers
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    // Form submit handled by Shopify {% form 'customer' %} — normal submission, page reloads
    // On reload, Liquid renders success state and inline script auto-opens popup + sets localStorage

    // Copy code button
    var copyBtn = popup.querySelector('[data-popup-copy]');
    var codeEl = popup.querySelector('[data-popup-code]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var code = codeEl.textContent.trim();
        var originalText = copyBtn.textContent;
        function showCopied() {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = originalText; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showCopied).catch(showCopied);
        } else {
          // Fallback for older browsers
          var range = document.createRange();
          range.selectNode(codeEl);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
          try { document.execCommand('copy'); } catch (err) {}
          window.getSelection().removeAllRanges();
          showCopied();
        }
      });
    }
  })();

});
